export type Lang = 'cs' | 'en' | 'vi' | 'uk';

export const DEFAULT_LANG: Lang = 'en';
export const STORAGE_KEY = 'guestbook_lang';

export const LANGS: { code: Lang; flag: string; label: string }[] = [
  { code: 'cs', flag: '🇨🇿', label: 'Čeština' },
  { code: 'en', flag: '🇬🇧', label: 'English' },
  { code: 'vi', flag: '🇻🇳', label: 'Tiếng Việt' },
  { code: 'uk', flag: '🇺🇦', label: 'Українська' },
];
